import { ObjectType } from '@/@types/graphql-types';
import { isArbitrating } from '@/helpers/composables/useArbitrage';

export enum BuyBoxFilterOptions {
	BEST = 'all',
	SUBSCRIPTION = 'flatrate',
	FREE = 'free',
	FAST_TV = 'fast',
	BUY = 'buy',
	RENT = 'rent',
}

export const buyboxExp4Validation = (
	objectType: ObjectType,
	isLoggedIn: boolean,
	isTitleUpcoming: boolean,
	offers: any[],
	onlyHasCinemaOffers: boolean | undefined,
	isBuyboxRevampExperiment: boolean
) => {
	return (
		objectType === ObjectType.Movie &&
		!isLoggedIn &&
		!isTitleUpcoming &&
		offers.length > 0 &&
		!onlyHasCinemaOffers &&
		isBuyboxRevampExperiment &&
		!isArbitrating.value
	);
};
